import React, { useRef } from 'react';

import { useLogin } from 'src/hooks/useLogin';

import Button from '@helsenorge/designsystem-react/components/Button';

interface SkjemaLoginButtonProps {
  buttonText: string;
  doNotRender?: boolean;
}

const SkjemaLoginButton = ({ buttonText }: SkjemaLoginButtonProps): React.JSX.Element => {
  const { login } = useLogin();
  const buttonRef = useRef<HTMLButtonElement>(null);

  return (
    <Button
      ref={buttonRef}
      onClick={(): void => {
        login(buttonRef);
      }}
    >
      {buttonText}
    </Button>
  );
};

export default SkjemaLoginButton;
